export const CAM_PAGE_ANALYTICS_ACTION = 'CAM_PAGE_ANALYTICS_ACTION';

export const PROMOTIONAL_ANALYTICS_ACTION = 'PROMOTIONAL_ANALYTICS_ACTION';

export default CAM_PAGE_ANALYTICS_ACTION;
